import ISilver from './ABI/pool.json'
import {
    USDT,
    SilverAddress,
    MultiCallAddress
} from './contract'

import {
    OnBlock,
    WeiToUnits,
    EtherToWei,
    Erc20,
    MultiCall,
    CreateProviderForRpc,
    GetGlobalSigner,
    CreateContract,
    DEFAULT_ACCOUNT,
    BN,
    // SignApproves,
    SwitchChain,
    Approves,
    BigToString,
    ZERO_ADDRESS
} from '../ethers/e'



// interface SilverPool {
//     // Contribution value token address
//     function usdt() external view returns(address);
//     function cv() external view returns(address);
//     function usdg() external view returns(address);
//     function founder() external view returns(address);
//     function dever() external view returns(address);

//     // userWallte.balanceOfUSDG +-1 => supplyOfUSDG +-1: supplyOfUSDG == sum(userWallte.balanceOfUSDG)
//     function supplyOfUSDG() external view returns(uint256);
//     function totalUnlockedUSDG() external view returns(uint256);
//     function totalGoldUnlcokableUSDG() external view returns(uint256);
//     function totalGoldLockUSDG() external view returns(uint256);

//     function interest7Days() external view returns(uint256);
//     function recruitmentTime() external view returns(uint256);
//     function hardCap() external view returns(uint256);
//     function silverRewardRate() external view returns(uint256);

//     function setPoolConfiguration(uint,uint,uint,uint) external;

//     function userWallet(address) external view returns(UserWallet memory);
//     function goldUser(address) external view returns(GoldUser memory);

//     function updatePool(uint) external;
//     function invest(uint, uint, address, uint16[] calldata) external;
//     function unlockUser(address, uint16[] calldata) external returns(uint);

//     function swap(uint, bool) external;
//     function buySilver() external;
//     function bindSilver(address) external;
//     function allPool() external view returns(Pool[] memory);
//     function getUserPools(address) external view returns(UserPostion[] memory);
//     function buyGoldPostion(uint) external;
//     function unlockGold(address) external;
//     function goldPostion(address) external view  returns(GoldPostion[] memory);
//     function bindGold(address) external;
//     function buyGold() external; 
// }

export function SilverPool() {
    return CreateContract(SilverAddress, ISilver, GetGlobalSigner())
}

export function Usdt() {
    return {
        token: USDT,
        contract: Erc20(USDT[0], GetGlobalSigner())
    }
}

export function Multi() {
    return MultiCall(MultiCallAddress, GetGlobalSigner())
}




export const INIT_POOLS = {
    totalU: 0,
    usdgBalance: 0,
    usdtBalance: 0,
    cvWithdrawn: 0,
    totalLockedUSDG: 0,
    unlockableOfUser: 0,
    totalInvestReward: 0,
    totalGoldUnlcokableUSDG: 0,
    totalLocked: 0,
    teamShare: 0,
    silverVIP: false,
    cvBalance: 0,
    sponsor: '',
    pools: [],
    progressing: [],
    userSilverPools: [],
    unlockPids: [],
    poolLength: 0,
    gold: {
        vip: false,
        inviter: '',
        teamPerformance: 0,
        position: [],
        totalUnlockable: 0,
        totalFunds: 0
    }
}


export async function InitSilver(account) {

    // account = '0x3F149a7b31cb2E566C64662B85eb2f7001bB7fD3'

    if (account === DEFAULT_ACCOUNT) {
        return INIT_POOLS
    }
    const silverContract = SilverPool()
    const usdt = Usdt()
    const multiCall = Multi()
    // console.log(account, await usdt.contract.balanceOf(account),' account')
    
    const results = await multiCall.all({
        usdt: usdt.contract.calls.balanceOf(account),
        usdgWallet: silverContract.calls.userWallet(account),
        // silverPools: silverContract.calls.allPool(),
        // silverPoolsOfUser: silverContract.calls.getUserPools(account),
        // totalLockedUSDG: silverContract.calls.totalUnlockedUSDG(),
        sponsor: silverContract.calls.sponsor(account),
        poolsWithUser: silverContract.calls.allPoolsWithUser(account),
        goldUser: silverContract.calls.goldUser(account),
        goldPostion: silverContract.calls.goldPostion(account),
        totalGoldUnlcokableUSDG: silverContract.calls.totalGoldUnlcokableUSDG(),
        totalGoldLockUSDG: silverContract.calls.totalGoldLockUSDG()
    })


    // console.log(
    //     results
    // )


    const now = new Date() / 1000

    const usdgBalance = WeiToUnits(results.usdgWallet.balanceOfUSDG)
    const usdtBalance = WeiToUnits(results.usdt)
    const silverVIP = results.usdgWallet.isSilverVIP
    const cvBalance = WeiToUnits(results.usdgWallet.totalStakedUSDG)
    const cvWithdrawn = WeiToUnits(results.usdgWallet.withdrawnCV)

    let sponsor = results.sponsor
    sponsor = sponsor === ZERO_ADDRESS ? '' : sponsor
    
    //////// user ////////
    // 可以收割的pids
    const unlockPids = []
    // 总的锁定的 USDG
    let totalLocked = BN(0)
    // 锁定了还没释放的 USDG
    let unlockableOfUser = BN(0)
    let teamShare = BN(0)
    let totalInvestReward = BN(0)
    let userSilverPools = []


    let totalLockedUSDG = BN(0)
    const pools = results.poolsWithUser.map((v,i) => {
        let end = v.endTime.toNumber()
        let recruitmentTime = v.recruitmentTime.toNumber()
        let startTime = v.startTime.toNumber()
        let endDate = end === 0 ? '--' : end === 1 ? 'fail' : new Date(end*1000).Format("yyyy.MM.dd hh:mm:ss")
        // console.log(endDate, '  endDate')
        // if (end !== 0)
        totalLockedUSDG = totalLockedUSDG.add(v.fundsRaised.mul(v.interestPayableRate.add(10000)).div(10000))
        // start----------recruitmentTime------------end--------
        // funding=0 | expire=1 | relaving=2 | ended=3
        // 募集中 startTime + recruitmentTime > now
        // 过期 now >= startTime + recruitmentTime && end === 0 || end === 1
        // 释放中 end > now
        // 已完成 now >= end && end > 1
        let status;
        if (startTime + recruitmentTime > now) {
            if (end > 1) {
                status = 2
            } else {
                status = 0
            }
        } else {
            if (end <= 1) {
                status = 1
            } else {
                if (end > now) {
                    status = 2
                } else {
                    status = 3
                }
            }
        }


        {
            // user
            const pool = v
            const pId = i
            const endTime = end
            const invet = v.funds.mul(v.interestPayableRate).div(10000)
            const funds = WeiToUnits(v.funds)
            const shareReward = WeiToUnits(v.silverEarned)
            const withdrawn = WeiToUnits(v.withdrawn)
            const hadPostion = (shareReward*1 + funds*1) > 0

            // if (endTime > 1) {
            //     teamShare = teamShare.add(v.silverEarned)
            // }
            // 总仓位 locked
            let locked = v.funds
            // let lockedReward = BN(0)
            // ended=3
            // console.log(status, pId)
            let team = BN(0)
            if (status === 2 || status === 3) {
                locked = locked.add(invet)
                totalInvestReward = totalInvestReward.add(invet)
                team = v.silverEarned
                teamShare = teamShare.add(v.silverEarned)
                unlockableOfUser = unlockableOfUser.add(team)
            }
            const unlockable = endTime <= 0 ? 0 : WeiToUnits(locked.add(v.silverEarned))
    
            totalLocked = totalLocked.add(locked.add(team).sub(v.withdrawn))
            // .sub(v.withdrawn)
            if (status !== 0 && status !== 2) {
                const netUnlock = locked.sub(v.withdrawn)
                unlockableOfUser = unlockableOfUser.add(netUnlock)
                if (!netUnlock.add(team).eq(0)) {
                    unlockPids.push(pId)
                }
            }
            
    
            locked = WeiToUnits(locked)

            userSilverPools.push({
                pId,
                startTime: pool.startTime.toNumber(),
                endTime,
                funds,
                shareReward,
                withdrawn,
                unlockable,
                hadPostion,
                reward: locked,
                locked,
                status,
                endDate
            })
        }



        return {
            pId: i,
            endDate,
            endTIme: end,
            fundsRaised: WeiToUnits(v.fundsRaised),
            hardCap: WeiToUnits(v.hardCap),
            interestPayableRate: v.interestPayableRate.toNumber() / 100,
            recruitmentTime,
            startTime,
            remainFunds: WeiToUnits(v.hardCap.sub(v.fundsRaised)),
            status
        }
    }).sort((a,b) => b.startTime - a.startTime)
    const progressing = pools.filter(v => v.endTIme === 0)
    
    
    // // only success
    // let totalLockedUSDG = WeiToUnits(results.totalLockedUSDG) // BN(0)

    
    userSilverPools = userSilverPools.filter(v => v.hadPostion).sort((a,b) => {
        // if (a.endTime > 1) return b.endTime - a.endTime
        return b.endTime - a.endTime //&& b.pId - a.pId
    })
    
    totalLocked = WeiToUnits(totalLocked)
    teamShare = WeiToUnits(teamShare)
    unlockableOfUser = WeiToUnits(unlockableOfUser)
    totalInvestReward = WeiToUnits(totalInvestReward)



    const gold = {}
    {
        const user = results.goldUser

        const vip = user.isVIP
        const inviter = user.inviter === ZERO_ADDRESS ? '' : user.inviter
        const teamPerformance = WeiToUnits(user.teamPerformance)
        
        gold.vip = vip
        gold.inviter = inviter
        gold.teamPerformance = teamPerformance

        const unlockPids = []
        let totalLocked = BN(0)
        let totalUnlockable = BN(0)
        const position = results.goldPostion
        gold.position = position.map((v ,i)=> {
            const endTime = v.endTime.toNumber()
            // const hours6 = 6 * 3600
            // const startTime = endTime - 7 * 24 * 3600 - hours6
            // const freezenTime = startTime + hours6
            let endDate =new Date(endTime*1000).Format("yyyy.MM.dd hh:mm:ss")



            const hours6 = 5 * 3600
            const startTime = endTime - 7 * 24 * 3600 - hours6
            const freezenTime = startTime + hours6

            let unlockable = BN(0)

            totalLocked = totalLocked.add(v.unlockable)

            // 1 releaved | 0 freezen | 2 releaving
            let status = 0;
            if (now > endTime) {
                status = 1
                unlockPids.push(i)
            } else if (now > freezenTime) {
                status = 2
            }

            if (status===1) {
                unlockable = unlockable.add(v.unlockable.sub(v.unlocked))
            }
            totalUnlockable = totalUnlockable.add(unlockable)
            return {
                pId: i,
                status,
                endTime,
                startTime,
                freezenTime,
                unlockable: WeiToUnits(unlockable),
                locked: WeiToUnits(v.unlockable),
                unlocked: WeiToUnits(v.unlocked),
                endDate
            }
        })
        gold.totalUnlockable = WeiToUnits(totalUnlockable)
        gold.totalLocked = WeiToUnits(totalLocked)
        gold.totalFunds = WeiToUnits(totalLocked.div(1036).mul(1000))
        gold.unlockPids = WeiToUnits(totalLocked)
        
    }



    // 显示需要
    // totalLockedUSDG = totalLockedUSDG.add(results.totalGoldLockUSDG)
    totalLockedUSDG = WeiToUnits(totalLockedUSDG)


    return {
        totalU: WeiToUnits(results.usdgWallet.balanceOfUSDG.add(results.usdt)),
        usdgBalance,
        usdtBalance,
        silverVIP,
        cvBalance,
        pools,
        progressing,
        userSilverPools,
        cvWithdrawn,
        totalLockedUSDG,
        unlockableOfUser,
        totalInvestReward,
        teamShare,
        sponsor,
        totalLocked,
        unlockPids,
        gold,
        totalGoldUnlcokableUSDG: WeiToUnits(results.totalGoldLockUSDG),
        poolLength: results.poolsWithUser.length
    }
}

